import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <IndexSection />
        <TopicsSection />
        <CommentsSection />
        <ContactSection />
        <AboutSection />
        <CardsSection />
        <UpdatesSection />
        <AppSection />
        <RankingSection />
        <MediaSection />
        <FeaturesSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}